module.exports = __webpack_public_path__ + "static/media/femme.80129ac8.jpg";